import React from 'react'
import { useStyles } from './Styles'
import { NamedRoutes } from '../../routes'
import { Button } from '@material-ui/core'
import { Link } from 'react-router-dom'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import { FormattedMessage } from 'react-intl'
import { LanguageConsumer } from '../../context/LanguageContext'

const PageTitle = ({ title, subTitle, addNewButton, addButtonRoute, addButtonFunction, addButtonText, addButtonIcon, disabledButton, invoice, singleInvoice, extraButtons, wrap }) => {
  const classes = useStyles()
  let attributes = {
    component: Link,
    to: addButtonRoute
  }
  if (!!addButtonFunction) {
    attributes = {
      onClick: addButtonFunction
    }
  }


  return (
    <>
      {!!invoice &&
      <LanguageConsumer>
        {({ locale }) => (
          <Button size={'medium'} variant={'text'} color={'secondary'} component={Link} to={NamedRoutes.invoices}
                  className={classes.backBtn} disableRipple disableElevation>
            <KeyboardBackspaceIcon className={locale === 'ar' ? 'flip-direction' : ''}/> <FormattedMessage
            id='Invoice.BackButton.Title'/>
          </Button>
        )}
      </LanguageConsumer>
      }
      <div className={classes.pageTitleWrapper + (!!invoice ? ' invoice' : '') + (!!wrap ? ' wrap' : '')}>
        {!!subTitle ? <div className={classes.pageTitleContainer}>
            <h1 className={classes.pageTitle + (!!singleInvoice ? ' single-invoice' : '')}>{title}</h1>
            <h4>{subTitle}</h4>
          </div> :
          <h1 className={classes.pageTitle + (!!singleInvoice ? ' single-invoice' : '')}>{title}</h1>
        }
        {(!!extraButtons || !!addNewButton) &&
        <div className={classes.pageActions}>
          {!!extraButtons && extraButtons}
          {!!addNewButton &&
          <Button size={'large'} variant={'contained'} color={'secondary'} {...attributes}
                  className={classes.addBtn} disabled={!!disabledButton}>
            {addButtonIcon || ''} {addButtonText}
          </Button>}
        </div>
        }
      </div>
    </>
  )
}

export default PageTitle
